<script>
export default {
  props: {
    obj: {
      type: Object,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    size: {
      type: String,
      required: false,
      default: () => {
        return "11px";
      },
    },
  },
  render: function () {
    if (!this.obj) {
      return;
    }
    let h = this.$createElement;
    let colour = this.obj.colour;
    if (!colour) colour = "#505050";
    let bgColour = this.obj.bg_colour ? this.obj.bg_colour : null;

    if (!bgColour) {
      if (!this.isHexLight(colour)) bgColour = `#${this.lightenColor(colour)}`;
      else bgColour = `#${this.darkenColor(colour)}`;
    }
    let icon = [this.obj.name];
    if (this.showIcon) {
      icon.push(
        h(
          "i",
          {
            class: ["el-icon-arrow-down", "el-icon--right"],
          },
          "",
        ),
      );
    }
    let content = h(
      "div",
      {
        style: {
          color: colour,
          "background-color": bgColour,
          "text-align": "center",
          "text-transform": "uppercase",
          padding: "3px 10px",
          "border-radius": "5px",
          "font-size": this.size ? this.size : "11px",
          border: `1px solid ${bgColour}`,
          display: "inline-block",
          "font-weight": "bold",
        },
      },
      icon,
    );
    return content;
  },
  methods: {
    lightenColor(color, percent = 50) {
      if (!color) return;
      var num = parseInt(color.replace("#", ""), 16),
        amt = Math.round(2.55 * percent),
        R = (num >> 16) + amt,
        B = ((num >> 8) & 0x00ff) + amt,
        G = (num & 0x0000ff) + amt;

      return (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
        (G < 255 ? (G < 1 ? 0 : G) : 255)
      )
        .toString(16)
        .slice(1);
    },
    darkenColor(color, percent = 80) {
      var num = parseInt(color, 16);
      var r = (num >> 16) + percent;
      var b = ((num >> 8) & 0x00ff) + percent;
      var g = (num & 0x0000ff) + percent;
      var newColor = g | (b << 8) | (r << 16);
      return newColor.toString(16);
    },
    isHexLight(color) {
      const hex = color.replace("#", "");
      const c_r = parseInt(hex.substr(0, 2), 16);
      const c_g = parseInt(hex.substr(2, 2), 16);
      const c_b = parseInt(hex.substr(4, 2), 16);
      const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
      return brightness > 155;
    },
  },
};
</script>
